// SecurityOverviewWeb.jsx
import { Link } from 'react-router-dom';
import './SecurityOverviewWeb.css';

export default function SecurityOverview({ hasMySimpleDB }) {
  return (
    <section className="secov">
      <header className="secov__head">
        <h2 className="secov__title">Security Overview</h2>
        <p className="secov__lead">
          Keep your account protected by managing your password, two-factor
          authentication, recovery codes, and Sensitive Vault.
        </p>
      </header>

      <div className="secov__grid">
        {/* Password */}
        <article className="secov__card">
          <div className="secov__icon" aria-hidden>
            🔑
          </div>
          <div className="secov__body">
            <h3 className="secov__h3">Password</h3>
            <p className="secov__text">
              Choose a strong password with upper/lowercase letters, numbers,
              and symbols. Changing it periodically helps prevent unauthorized
              access.
            </p>
            <ul className="secov__bullets">
              <li>At least 8 characters</li>
              <li>Uppercase &amp; lowercase</li>
              <li>Number &amp; symbol</li>
            </ul>
          </div>
        </article>

        {/* 2FA */}
        <article className="secov__card">
          <div className="secov__icon" aria-hidden>
            📲
          </div>
          <div className="secov__body">
            <h3 className="secov__h3">Two-Factor Authentication</h3>
            <p className="secov__text">
              Add a one-time code from an authenticator app when signing in.
              This protects your account even if your password is known.
            </p>
            <ul className="secov__bullets">
              <li>Time-based codes (TOTP)</li>
              <li>Works with Authy, Google/Microsoft Authenticator, etc.</li>
              <li>Device-independent</li>
            </ul>
          </div>
        </article>

        {/* Recovery Codes */}
        <article className="secov__card">
          <div className="secov__icon" aria-hidden>
            🧾
          </div>
          <div className="secov__body">
            <h3 className="secov__h3">Two-Factor Recovery Codes</h3>
            <p className="secov__text">
              Generate one-time codes to regain access if you lose your
              authenticator device. Store them somewhere safe and offline.
            </p>
            <ul className="secov__bullets">
              <li>Single-use codes</li>
              <li>Regenerate anytime</li>
              <li>Keep offline (printed or password manager)</li>
            </ul>
          </div>
        </article>
        {hasMySimpleDB && (
          <>
            {/* Sensitive Vault */}
            <article className="secov__card">
              <div className="secov__icon" aria-hidden>
                🔐
              </div>
              <div className="secov__body">
                <h3 className="secov__h3">Sensitive Vault</h3>
                <p className="secov__text">
                  Review the encryption configuration and status of the vault
                  that protects your Sensitive entries.
                </p>
                <ul className="secov__bullets">
                  <li>AES-256-GCM encryption</li>
                  <li>Passphrase and recovery-key protection</li>
                  <li>Automatic session locking</li>
                </ul>
              </div>
            </article>
          </>
        )}
      </div>
    </section>
  );
}
